'use client';

import React from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export default function CtaSection() {
  return (
    <section className="py-20 sm:py-28 px-4 sm:px-6 lg:px-10" style={{ background: 'var(--background)' }}>
      <div className="max-w-3xl mx-auto text-center">
        <div className="glass-card rounded-3xl px-6 sm:px-12 py-14 sm:py-20 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-64 h-64 orb-purple pointer-events-none -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-64 h-64 orb-pink pointer-events-none translate-x-1/2 translate-y-1/2" />

          <div className="relative z-10">
            <p className="text-xs sm:text-sm font-semibold uppercase tracking-widest mb-5" style={{ color: 'var(--secondary)' }}>
              Get Started Today
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-8" style={{ color: 'var(--foreground)' }}>
              Turn Music Momentum<br />Into A Market.
            </h2>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
              <Link
                href="/sign-up-login-screen"
                className="btn-primary text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-3.5 glow-teal w-full sm:w-auto justify-center"
              >
                Get Started
              </Link>
              <Link
                href="/music-discovery-feed"
                className="btn-secondary text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-3.5 w-full sm:w-auto justify-center"
              >
                <ArrowRight size={18} />
                Explore Campaigns
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}